var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMemberMetalDeck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: silver;\r\n        stroke: #000;\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconMemberMetalDeck") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Border"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 48,
    height: 48
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "MemberMetalDeck"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3.25 29 8.25 29 14.02 19 24.02 19 29.8 29 39.55 29 45.25 19.12 44.89 18.75 39.26 28.5 30.09 28.5 24.31 18.5 13.73 18.5 7.96 28.5 3.25 28.5 3.25 29"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 48,
    height: 48
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMemberMetalDeck);
export default __webpack_public_path__ + "static/media/IconMemberMetalDeck.a921df80bc1f29c8b75d7071a885c770.svg";
export { ForwardRef as ReactComponent };